export function highlightMarker(
  marker: google.maps.marker.AdvancedMarkerElement,
  style: "green" | "red" = "green"
) {
  if (!marker.element) {
    return;
  }

  if (style === "green") {
    marker.element.style.filter = "brightness(1.1) hue-rotate(90deg)";
  } else if (style === "red") {
    marker.element.style.filter = "brightness(1.1) hue-rotate(270deg)";
  }
}

export function clearMarkerHighlight(
  marker: google.maps.marker.AdvancedMarkerElement
) {
  if (marker.element) {
    marker.element.style.filter = "none";
  }
}
